import React, { useEffect, useState } from "react";
import axios from "../axiosInstance";
import { useParams } from "react-router-dom";
import SocialBarAd from "../components/SocialBarAd";
import HighPerformanceAd from "../components/HighPerformanceAd";

function Toast({ message, type = "error", onClose }) {
    return (
      <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
        <div className="flex items-center space-x-2">
          <span>{message}</span>
          <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
        </div>
      </div>
    );
  }

export default function PTPPage() {
  const [ad, setAd] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rewarded, setRewarded] = useState(false);
  const [reward, setReward] = useState(0);
  const [countdown, setCountdown] = useState(15);
  const initialBannerDuration = 15; // seconds
  const [secondsLeft, setSecondsLeft] = useState(initialBannerDuration);
  const [rewardShown, setRewardShown] = useState(false);
  const [showSocialBar, setShowSocialBar] = useState(true);
  const [toast, setToast] = useState({ message: "", type: "" });
  const referrer = document.referrer;
 
  const showToast = (message, type = "error") => {
    setToast({ message, type });
  setTimeout(() => setToast({ message: "", type: "" }), 3000);
};
 

  useEffect(() => {
    if (secondsLeft > 0) {
      const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      setRewardShown(true);
    }
  }, [secondsLeft]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ptp_code = params.get("ptp_code");

    axios.get(`/api/ptp/next?ptp_code=${encodeURIComponent(ptp_code)}`).then((res) => {
      setAd(res.data);
      setLoading(false);
    });
  }, []);


  useEffect(() => {
    if (!ad || rewarded) return;
  
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  
    if (countdown === 0 && !rewarded) {
      const params = new URLSearchParams(window.location.search);
      const ptp_code = params.get("ptp_code");
  
      axios
        .post("/api/ptp/visit", { ad_id: ad.ad_id, ptp_code: ptp_code, page_source: referrer,   })
        .then((res) => {
          
          //showToast(`${ad.username} earned ${res.data.reward} coinz`, "success");
          setReward(res.data.reward);
          setRewarded(true);
          setRewardShown(true);
          
        })
        .catch((err) => {
          showToast(`Error: ${err}`, "error");
        });
    }
  }, [countdown, ad, rewarded]);

  if (loading) return <div className="text-white p-4">Loading Ad...</div>;

  return (
    <>
    {toast.message && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ message: "", type: "" })}
        />
      )}

    <div className="relative h-screen w-full">
 
      {/* 🟦 Conteneur haut avec pub + bandeau */}
      <div className="fixed top-6 left-0 right-0 z-50 flex justify-center items-center px-4">
        {/* BANNIÈRE à gauche */}
        <div className="mr-4">
          <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90} />
        </div>

        {/* BANDEAU Coinz */}
        <div className="bg-white text-gray-900 border border-gray-300 rounded-xl px-5 py-3 shadow-xl flex items-center gap-3 text-sm font-semibold tracking-wide max-w-full">
          <img src="/logo192.png" alt="Coinz" className="h-6 w-6" />
          {!rewardShown ? (
            <span>
              {ad.username} is earning $ in coinz on <strong>CoinzUp.net</strong>...{" "}
              <span className="text-blue-600 font-bold">{countdown}s</span>
            </span>
          ) : (
            <span className="text-green-700 animate-pulse font-bold">
              {ad.username} just earned ${reward / 100000}!
            </span>
          )}
        </div>
      </div>

      <iframe
        src={ad.url}
        title="Ad"
        className="w-full h-full border-0"
        sandbox="allow-scripts allow-same-origin allow-forms"
      ></iframe>
      
    </div>
    </>
  );
}
